
import { computed, defineComponent } from "vue";
import { EyeIcon } from "@heroicons/vue/solid";
import action from "./action";

export default defineComponent({
  mixins: [action],

  components: {
    EyeIcon,
  },

  setup(props: any) {
    const route = computed(() => {
      return props.options.viewRoute(props.item);
    });

    return {
      route,
    };
  },
});
